import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "user-selector" }
const _hoisted_2 = {
  key: 0,
  class: "selected-family"
}
const _hoisted_3 = { key: 1 }

import { ref } from 'vue'
import { User, UserSort } from '@/gp/GroupAdminModel'
import { useUserStore } from '@/gp/UserStore'
import AutoCompleteInput from '@/util/AutoCompleteInput.vue'
import UserItem from './UserItem.vue'

interface UserSearchResult {
  value: string
  user: User
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserSelector',
  props: {
    modelValue: {}
  },
  emits: [
  'userSelected',
  'update:modelValue',
],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





__expose({
  clear,
  focus,
})

const autoCompleteInputRef = ref<InstanceType<typeof AutoCompleteInput>>()
const userStore = useUserStore()

function clear() {
  autoCompleteInputRef.value?.clear()
}

function focus() {
  autoCompleteInputRef.value?.focus()
}

async function searchUsers(query: string) {
  if (query.length < 3)
    return []

  const results = await userStore.searchUsersAsync({ name: query, sort: UserSort.GivenName, pageSize: 20 })
  return results.items.map(u => ({ value: u.id!, user: u }))
}

function getUserItemProps(r: { value: string }) {
  return { userId: r.value, selectMode: true }
}

function onResultSelected(r: UserSearchResult) {
  emit('userSelected', r.value)
  emit('update:modelValue', r.value)
}

function removeSelectedUser() {
  emit('update:modelValue', undefined)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(UserItem, {
            "user-id": _ctx.modelValue,
            "select-mode": "",
            onClick: removeSelectedUser
          }, null, 8, ["user-id"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(AutoCompleteInput, {
            ref_key: "autoCompleteInputRef",
            ref: autoCompleteInputRef,
            placeholder: "Type a user name",
            search: searchUsers,
            "item-component": UserItem,
            "get-component-props": getUserItemProps,
            onResultSelected: onResultSelected
          }, null, 512)
        ]))
  ]))
}
}

})